import React, { useEffect, useState } from 'react';
import SuccessAlert from '../../components/widgets/SuccessAlert';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import API from "../../network/ApiCall";
import LoadingSpinner from '../../components/widgets/LoadingSpinner';
import HeadingWithIcon from '../../components/widgets/HeadingWithIcon';
import AccountForm from '../../components/account/AccountForm';
import axiosInstance from '../../network/ApiCall';
import ErrorAlert from '../../components/widgets/ErrorAlert';
import { useNavigate } from "react-router-dom";
import { SYSTEM_UNION_CODE } from '../../config';

const EditUser = props => {

  const ACCOUNT_DETAILS_ENDPOINT = "/account/";

  const { t } = useTranslation();
  const params = useParams();
  const [defaultData, setDefaultData] = useState();
  const [loading, setLoading] = useState(true);
  const [formState, setFormState] = useState({ success: false, errorMessage: null, submissionDate: null });
  const unionModeEnabled = Boolean(SYSTEM_UNION_CODE);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const loadUser = async (id) => {
      setLoading(true)
      const url = ACCOUNT_DETAILS_ENDPOINT + id;

      try {
        const response = await API.get(url);
        setDefaultData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("ERROR LOADING ACCOUNT: ", error);
        setLoading(false);
      };
    };

    loadUser(params.id);

  }, [params.id]);

  const onSubmit = (data, e) => {

    axiosInstance.post(ACCOUNT_DETAILS_ENDPOINT + params.id, data)
      .then(response => {
        if (response.data.id) {
          navigate("/app/users", { state: { message: t("account:msgUpdatedSuccess") } })
        } else {
          setFormState({ success: false, error: "Error in response", submissionDate: new Date() });
        }
      })
      .catch(error => {
        setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate: new Date() });
      })
  };

  const onError = (errors, e) => console.log("ON ERROR", errors, e);

  const toggleActive = () => {
    setLoading(true);
    axiosInstance.patch(ACCOUNT_DETAILS_ENDPOINT + params.id + "/toggleActiveStatus")
      .then(() => {
        navigate("/app/users", { state: { message: t("account:msgUpdatedSuccess") } })
      }).finally(() => {
        setLoading(false)
      })
  }

  return (


      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>
            <li className="breadcrumb-item active" aria-current="page"><Link to="/app/users">{t('users:hdgHeading')}</Link></li>
          </ol>
        </nav>
        <div className="m-2 m-sm-5">


          <div className="card my-5">
            <div className="card-header ">
              <div className="row justify-content-between">
                <div className="col">
                  <HeadingWithIcon icon="fa-user-edit">{t('account:hdgEdit')}</HeadingWithIcon>
                </div>
                <div className="col text-end">
                  {!loading && !unionModeEnabled && <>
                    {defaultData.status === "ACTIVE" ?
                      <button className="btn btn-outline-danger" type="button" onClick={toggleActive}>
                        {t('account:btnDeactivate')}
                      </button>
                      :
                      <button className="btn btn-success" type="button" onClick={toggleActive}>
                        {t('account:btnActivate')}
                      </button>
                    }
                  </>
                  }
                </div>
              </div>
            </div>
            <div className="card-body ">

              <div className="row ">

                <div className="col-md-8 offset-md-2 mb-5">



                  <SuccessAlert message={location?.state?.message} />
                  <ErrorAlert error={formState.error} lastStateUpdate={formState.submissionDate} />

                  {loading ? <LoadingSpinner /> : <>
                    {defaultData && <AccountForm defaultValues={defaultData} onSubmit={onSubmit} onError={onError} />}
                  </>}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  )
};

EditUser.propTypes = {

};

export default EditUser;
